import { z } from 'zod'

export const previsionsSearchSchema = z.object({
  storeIds: z.array(z.number().int().positive()).optional().default([]),
  horizon: z.number().int().min(1).max(60).optional().default(12),
  view: z.enum(['calendaire', 'cohorte']).optional().default('calendaire'),
  tab: z.enum(['forecast', 'backtest']).optional().default('forecast'),
})

export type PrevisionsSearch = z.infer<typeof previsionsSearchSchema>
